export const extractProductIdList = (productList) => {
  return productList.map((product) => {
    return [product.ProductIdentifier];
  });
};
